/** 回购页面 **/
<template>
  <div class="home data-panel-home">
    <Layout
      type="HOME"
      :pageTitle="$t('pageTitle')"
      titleSrc="/menu/homeIcon_black.png"
    >
      <Tips
        :title="$t('tipsTitle')"
        :tips="$t('tipsDetail')"
        class="buyback-tips"
      />
      <CommitExchange></CommitExchange>
      <ExchangeList></ExchangeList>
    </Layout>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import { mapState, mapActions, mapMutations } from "vuex";
import Layout from "@/components/DatePanel/Layout.vue";
import Tips from '@/components/Common/Tips.vue';
import CommitExchange from '@/components/DatePanel/Exchange/CommitExchange.vue';
import ExchangeList from '@/components/DatePanel/Exchange/ExchangeList.vue';

export default {
  name: "home",
  components: {
    Header,
    Layout,
    Tips,
    CommitExchange,
    ExchangeList
  },
  data() {
    return {};
  },
  computed: mapState({
    inviteCodeStatus: state => state.inviteCode.status
  }),
  created() {
    let that = this;
  },
  methods: {
    ...mapActions([""])
  }
};
</script>

<style scoped lang="stylus"></style>

<i18n>
{
  "en": {
    "pageTitle": "JD卡兑换",
    "tipsDetail": [
      "1.提供面额为 5元、10元、20元、50元、100元（100元需完成<router-link>身份验证<===>/contact<router-link>）面额 JD卡 的兑换，单日上线为100元，月上限为800元，超额请使用提现功能。",
      "2.兑换请先选择面额及所需兑换张数，系统会计算出需要支付的 BxC 数量，确认兑换后直接使用账户余额支付所需数量的 BxC。",
      "3.<special>支付后需要 1-2 小时完成兑换流程<special>，在此期间请勿进行提现操作，若兑换扣款时余额不足会导致兑换失败。",
      "4.兑换完成后，请在下方兑换记录中点击<special>查看卡密<special>获取 JD卡，为了账户资金安全，每次操作均需要进行账户安全性验证。",
      "5.复制卡密后，请打开JD官网（jd.com），登录并在我的钱包中选择礼品卡，输入卡密即可兑换，移动端请点击 我的-我的钱包-礼品卡-绑定新卡 完成操作。"
    ],
    "tipsTitle": "兑换注意事项"  
  }
}
</i18n>
